var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.labelName ? _c('label', [_vm._v(_vm._s(_vm.labelName) + ":")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.options, function (opt) {
    return [_c('label', {
      staticClass: "option",
      attrs: {
        "for": opt.value
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": opt.value,
        "name": _vm.name,
        "disabled": _vm.disabled
      },
      domProps: {
        "value": opt.value,
        "checked": _vm.isChecked(opt.value)
      },
      on: {
        "click": function ($event) {
          return _vm.selected(opt.value);
        }
      }
    }), _vm._v("\n      " + _vm._s(opt.text) + "\n    ")]), _vm._v(" "), opt.hasOwnProperty('description') ? _c('div', {
      staticClass: "radio-option-description"
    }, [_vm._v("\n      " + _vm._s(opt.description) + "\n    ")]) : _vm._e()];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }